import { render } from "./SideRulesListTable.vue?vue&type=template&id=cd57b1d0&scoped=true"
import script from "./SideRulesListTable.vue?vue&type=script&lang=js"
export * from "./SideRulesListTable.vue?vue&type=script&lang=js"

import "./SideRulesListTable.vue?vue&type=style&index=0&id=cd57b1d0&lang=less&scoped=true"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd57b1d0"]])

export default __exports__